import { Button, message, Modal } from "antd";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { GIVE_EXTRA_PLAID_ATTEMPT, RUN_REGISTRATION } from "../../../constants/StringConstants";
import API from "../../../services/API";
import CustomText from "../../CustomText";
import LoaderComponent from "../../Loader";
import { isSupportAgent2 } from "../../../helpers/genericHelper";

export default function RegistrationDetails({ registrationDetails = [], reloadData }) {
  const [modalVisible, setModalVisible] = useState(false);
  const [plaidModalVisible, setPlaidModalVisible] = useState(false);
  const [modalLoading, setModalLoading] = useState(false);


  const [adminButton, setAdminButton] = useState(false);
  const [giveExtraPlaid, setGiveExtraPlaid] = useState(false);

  let { userId } = useParams();
  useEffect(() => {
    setAdminButton(
      registrationDetails?.registrationDiagnostics?.adminFix ===
      RUN_REGISTRATION
    );
    setGiveExtraPlaid(isSupportAgent2() && (registrationDetails?.registrationDiagnostics?.adminFix ===
      GIVE_EXTRA_PLAID_ATTEMPT));
  }, [registrationDetails]);

  const closeModal = () => {
    setModalVisible(false);
    setPlaidModalVisible(false);
  };
  const adminFixRegistration = async () => {
    try {
      await API.runRegistration(userId);
      setModalVisible(false);
      if (reloadData) reloadData();
    } catch (ex) {
      message.error("Unable to run registration.");
    } finally {
      setModalVisible(false);
      message.success("Registration ran successfully ");
    }
  };

  const extraPlaidAttempt = async () => {
    try {
      setModalLoading(true);
      await API.extraPlaidAttempt(userId);
      message.success("Your request has been submitted.");
      if (reloadData) reloadData();
    } catch (ex) {
      message.error("Failed to submit Plaid Request!");
    } finally {
      closeModal();
      setModalLoading(false);
    }
  };

  return (
    <div className="ant-list-box table-responsive" style={{ maxHeight: 400 }}>
      <table className="width-100">
        <thead>
          <tr>
            <th>User Id</th>
            <th>Registration Status</th>
            <th>Fail Action</th>
            <th style={{ maxWidth: 50 }}>Fail Step</th>
            <th>Fail Reason</th>
            <th>Fail Remedy</th>
            <th>Admin Fix</th>
            {giveExtraPlaid && <th>Extra Plaid Request</th>}

          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <CustomText dataSet={registrationDetails} property1={"userId"} />
            </td>
            <td>
              <CustomText
                dataSet={registrationDetails}
                property1={"registrationStatus"}
              />
            </td>
            <td>
              <CustomText
                dataSet={registrationDetails?.failAction}
                property1={"failAction"}
              />
            </td>
            <td>
              <CustomText
                dataSet={registrationDetails?.registrationDiagnostics}
                property1={"failStep"}
              />
            </td>
            <td style={{ "whiteSpace": "pre-wrap", width: "21%" }}>

              <CustomText
                dataSet={registrationDetails?.registrationDiagnostics}
                property1={"failReason"}
              />
            </td>
            <td style={{ "whiteSpace": "pre-wrap" }}>
              <CustomText
                dataSet={registrationDetails?.registrationDiagnostics}
                property1={"failRemedy"}
              />
            </td>
            <td>
              <div style={{ display: 'flex' }}>
                {adminButton ? (
                  <>
                    <Button type={"primary"} onClick={() => setModalVisible(true)} style={{ marginRight: 5 }}>
                      <CustomText
                        dataSet={registrationDetails?.registrationDiagnostics}
                        property1={"adminFix"}
                      />
                    </Button>
                  </>
                ) : (
                  <CustomText
                    dataSet={registrationDetails?.registrationDiagnostics}
                    property1={"adminFix"}
                  />
                )}
              </div>
            </td>

            {giveExtraPlaid && <td>
              <Button type={"primary"} onClick={() => setPlaidModalVisible(true)}>
                Extra plaid attempt
              </Button>
            </td>}
          </tr>
        </tbody>
      </table>
      <Modal
        title={"Confirmation"}
        centered
        mask={true}
        maskClosable={true}
        destroyOnClose={true}
        closable={true}
        visible={modalVisible}
        onOk={adminFixRegistration}
        onCancel={closeModal}
        className="confirm-modal"
      >
        <p>Are you sure you want to Run Registration ?</p>
      </Modal>

      <Modal
        title={"Confirmation"}
        centered
        mask={true}
        maskClosable={true}
        destroyOnClose={true}
        closable={true}
        visible={plaidModalVisible}
        onOk={extraPlaidAttempt}
        okText={"Continue"}
        onCancel={closeModal}
        className="confirm-modal"
      >
        {modalLoading ?
          <LoaderComponent /> :
          <p>Review the Plaid tab and investigate why the other Plaid accounts failed to link before confirming. Once confirmed this information will be lost and could be vital in assisting the customer</p>}

      </Modal>

    </div>
  );
}
